import React from 'react';
import Services from '../Services/Services';
import Spot from '../Spot/Spot';

const Home = () => {
    return (
        <div>
            <Services></Services>
            <Spot></Spot>
        </div>
    );
};

export default Home;